<script lang="ts">
  import { navigate } from "../../app.logic";

  import type {
    ITimesheetDTO,
    ITimesheetEntryDTO,
  } from "../../services/DTO/timesheet-dto";
  import { selection, setSelection } from "./timesheet.store";

  export let timesheet: ITimesheetDTO = null;

  function isEntrySelected(sel: any, entry: ITimesheetEntryDTO) {
    if (sel == null) return false;
    return sel.dateKey === entry.dateKey && sel.dossierId === entry.dossierId && sel.customerId === entry.customerId;
  }
</script>

{#if !!timesheet}
  <div class="timesheet">
    <div class="timesheet-row timesheet-header-row">
      <div class="timesheet-row-title noselect">Pratiche</div>
      <div class="timesheet-row-total noselect">Tot.</div>
      <div class="timesheet-row-entries">
        {#each timesheet.headers as header}
          <div
            class="timesheet-entry noselect"
            class:timesheet-festivity={header.festivity}
          >
            {header.title}
          </div>
        {/each}
      </div>
    </div>

    <!-- common row -->
    <div class="timesheet-row hoverable">
      <div class="timesheet-row-title noselect">
        {timesheet.commonRow.title}
      </div>
      <div class="timesheet-row-total noselect">
        <span class="number-value">
          {timesheet.commonRow.displayTotal}
        </span>
      </div>
      <div class="timesheet-row-entries">
        {#each timesheet.commonRow.entries as entry}
          <div
            class="timesheet-entry noselect"
            class:selected={isEntrySelected($selection, entry)}
            on:click={(_) => setSelection(entry)}
          >
            <span class="number-value">
              {entry.displayValue}
            </span>
          </div>
        {/each}
      </div>
    </div>

    <!-- customer rows (ordinary activities) -->
    {#each timesheet.customerRows as row}
      <div class="timesheet-row hoverable">
        <div class="timesheet-row-title noselect">
          <span
            class="timesheet-row-title-customer"
            title={row.customerName}
            on:click={(_) => navigate(`/customer/${row.customerId}`)}
          >
            {row.customerName}
          </span>
          <span
            class="timesheet-row-title-link"
            title={row.title}
            >{row.title}</span
          >
        </div>
        <div class="timesheet-row-total noselect">
          <span class="number-value">{row.displayTotal}</span>
        </div>
        <div class="timesheet-row-entries">
          {#each row.entries as entry}
            <div
              class="timesheet-entry noselect"
              class:invalid-date={!entry.validDate}
              class:selected={isEntrySelected($selection, entry)}
              on:click={(_) => setSelection(entry)}
            >
              <span class="number-value">
                {entry.displayValue}
              </span>
            </div>
          {/each}
        </div>
      </div>
    {/each}

    <!-- dossier rows -->
    {#each timesheet.dossierRows as row}
      <div class="timesheet-row hoverable">
        <div class="timesheet-row-title noselect">
          <span
            class="timesheet-row-title-customer"
            title={row.customerName}
            on:click={(_) => navigate(`/customer/${row.customerId}`)}
          >
            {row.customerName}
          </span>
          <span
            class="timesheet-row-title-link"
            title={row.title}
            on:click={(_) => navigate(`/dossier/${row.dossierId}`)}
            >{row.title}</span
          >
        </div>
        <div class="timesheet-row-total noselect">
          <span class="number-value">{row.displayTotal}</span>
        </div>
        <div class="timesheet-row-entries">
          {#each row.entries as entry}
            <div
              class="timesheet-entry noselect"
              class:invalid-date={!entry.validDate}
              class:selected={isEntrySelected($selection, entry)}
              on:click={(_) => setSelection(entry)}
            >
              <span class="number-value">
                {entry.displayValue}
              </span>
            </div>
          {/each}
        </div>
      </div>
    {/each}

    <!-- total row -->
    <div class="timesheet-row timesheet-totals-row">
      <div class="timesheet-row-title noselect">TOTALE</div>
      <div class="timesheet-row-total noselect">
        <span class="number-value">
          {timesheet.displayGrandTotal}
        </span>
      </div>
      <div class="timesheet-row-entries">
        {#each timesheet.headers as header}
          <div class="timesheet-entry noselect">
            <span class="number-value">
              {header.displayTotal}
            </span>
          </div>
        {/each}
      </div>
    </div>
  </div>
{/if}

<style>
  .timesheet-row {
    display: flex;
    flex-direction: row;
    width: 100%;
    border-bottom: 1px solid #ddd;
  }

  .timesheet-row.hoverable:hover {
    background: #fff8dc;
    -o-transition: all 0.1s ease-in-out;
    -webkit-transition: all 0.1s ease-in-out;
    -moz-transition: all 0.1s ease-in-out;
    -ms-transition: all 0.1s ease-in-out;
    transition: all 0.1s ease-in-out;
  }

  .timesheet-header-row {
    /* border-top: 1px solid #ccc; */
    text-align: center;
    font-weight: bold;
    background-color: #eeeeee;
    background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#f9f9f9),
      to(#eeeeee)
    );
    background-image: -webkit-linear-gradient(top, #f9f9f9, #eeeeee);
    background-image: -moz-linear-gradient(top, #f9f9f9, #eeeeee);
    background-image: -ms-linear-gradient(top, #f9f9f9, #eeeeee);
    background-image: -o-linear-gradient(top, #f9f9f9, #eeeeee);
    background-image: linear-gradient(top, #f9f9f9, #eeeeee);
    -webkit-box-shadow: 0 1px 0 rgba(255, 255, 255, 0.8) inset;
    -moz-box-shadow: 0 1px 0 rgba(255, 255, 255, 0.8) inset;
    box-shadow: 0 1px 0 rgba(255, 255, 255, 0.8) inset;
    /* border-top: none; */
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);
  }

  .timesheet-header-row .timesheet-entry {
    border-top: 1px solid #ddd;
    display: block;
    text-align: center;
  }

  .timesheet-header-row .timesheet-row-title {
    text-align: left;
    border-top: 1px solid #ddd;
    border-radius: 6px 0 0 0;
  }

  .timesheet-header-row .timesheet-row-total {
    border-top: 1px solid #ddd;
    display: block;
  }

  .timesheet-header-row .timesheet-entry:last-child {
    border-top: 1px solid #ddd;
    border-radius: 0 6px 0 0;
  }

  .timesheet-header-row .timesheet-entry.timesheet-festivity {
    color: #cc3333;
  }

  .timesheet-totals-row {
    font-weight: bold;
  }

  .timesheet-row-title {
    width: 30%;
    min-width: 30%;
    max-width: 30%;
    /*
    width: max-content;
    min-width: 200px;
    */
    padding: 4px 10px;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    vertical-align: middle;
  }

  .timesheet-row-total {
    display: flex;
    font-weight: bold;
    text-align: center;
    border-right: 1px solid #ddd;
    padding: 4px 10px;
    width: max-content;
    min-width: 80px;
  }

  .timesheet-row-entries {
    display: flex;
    flex-direction: row;
    flex: 1;
  }

  .timesheet-entry {
    display: flex;
    flex: 1;
    text-align: center;
    vertical-align: middle;
    border-right: 1px solid #ddd;
    padding: 4px 10px;
  }

  .timesheet-entry.invalid-date {
    background: #eaeaea;
  }

  .timesheet-entry.selected {
    background: #ffcc00 !important;
    outline: 1px solid #ffaa00;
    outline-offset: -1px;
    color: #222;
  }

  .timesheet-row-title-customer {
    display: block;
    font-size: 0.7rem;
    /* font-weight: bold; */
    color: #777;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .timesheet-row-title-link {
    display: block;
    font-size: 0.85rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .timesheet-row-title-customer:hover,
  .timesheet-row-title-link:hover {
    text-decoration: underline;
    cursor: pointer;
  }

  .number-value {
    margin: auto;
  }

  /*
  .timesheet-entry:hover {
    background-color: #777;
    color: #eee;
  }
  */
</style>
